import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Minha empresa é elegível para o Mercado Livre de Energia?',
      answer:
        'Empresas que gastam mais de R$10.000 mensais com energia elétrica e são consumidores do Grupo A (média e alta tensão) com demanda contratada a partir de 30kW geralmente são elegíveis. Nossa análise gratuita verificará se sua empresa atende aos requisitos.',
    },
    {
      question: 'Quanto tempo leva o processo de migração?',
      answer:
        'O processo completo de migração geralmente leva de 3 a 6 meses, dependendo da complexidade da sua instalação e da documentação necessária. Durante todo esse período, cuidamos de toda a burocracia para você.',
    },
    {
      question: 'Existe risco de ficar sem energia durante a transição?',
      answer:
        'Não. A transição é totalmente segura e sua empresa não ficará sem energia nem por um segundo. O fornecimento é garantido durante todo o processo de migração.',
    },
    {
      question: 'Preciso fazer algum investimento em equipamentos?',
      answer:
        'Na maioria dos casos, não é necessário investimento em equipamentos. A migração é feita utilizando a infraestrutura existente. Caso seja necessária alguma adequação, informaremos na análise de viabilidade.',
    },
    {
      question: 'Como funciona a cobrança após a migração?',
      answer:
        'Após a migração, você receberá duas faturas: uma da distribuidora local (referente ao uso da rede) e outra do fornecedor escolhido (referente à energia consumida). O valor total será significativamente menor do que você paga atualmente.',
    },
    {
      question: 'E se as regras do setor elétrico mudarem?',
      answer:
        'Nossa equipe monitora constantemente as mudanças regulatórias e mantém você informado sobre qualquer alteração que possa impactar seus contratos. Além disso, oferecemos suporte contínuo para renegociação quando necessário.',
    },
    {
      question: 'A análise de viabilidade realmente não tem custo ou compromisso?',
      answer:
        'Sim, a análise é 100% gratuita e sem compromisso. Você receberá um relatório completo com todas as informações necessárias para tomar uma decisão informada, sem nenhuma obrigação de contratação.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-12 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-4xl font-bold text-[#003366] mb-6 md:mb-8 text-center leading-tight">
          PERGUNTAS FREQUENTES SOBRE A MIGRAÇÃO PARA O MERCADO LIVRE DE ENERGIA...
        </h2>
        <p className="text-center text-base md:text-lg text-[#003366] font-semibold mb-8 md:mb-12 max-w-4xl mx-auto">
          Tudo o que você precisa saber antes de tomar sua decisão
        </p>

        <div className="max-w-4xl mx-auto mb-8 md:mb-12">
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-gray-200">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="flex justify-between items-center w-full text-left font-semibold text-[#003366] py-3 md:py-4 hover:text-[#4A90E2] transition-colors duration-300 cursor-pointer text-sm md:text-base"
                >
                  <span className="pr-4">{faq.question}</span>
                  <i
                    className={`ri-arrow-down-s-line text-xl md:text-2xl transition-transform duration-300 w-6 h-6 flex items-center justify-center flex-shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm md:text-base text-gray-700">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <a
            href="https://wa.me/5589933009903?text=Olá,%20Satori%20Energia!%20Tenho%20interesse%20em%20saber%20mais%20sobre%20a%20migração%20para%20o%20Mercado%20Livre%20de%20Energia."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-5 md:px-6 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-lg md:text-xl mr-2 w-5 h-5 flex items-center justify-center"></i>
            AINDA TENHO DÚVIDAS - FALAR COM UM ESPECIALISTA
          </a>
        </div>
      </div>
    </section>
  );
}
